import { createInjectable } from "ngxtension/create-injectable";
import { HttpClient, HttpContext } from "@angular/common/http";
import { signal, computed, inject } from "@angular/core";
import { Router } from "@angular/router";
import { catchError, finalize, of, switchMap, take, tap } from "rxjs";
import { AUTH_DAVESA_API } from "app/core/auth-davesa/auth-davesa-api.component";
import { AuthDavesaV2Service } from "app/core/auth-davesa/auth-davesa-v2.service";
import { SitesV2Service } from "app/modules/davesa/administration/sites/sites-v2.service";
import { StudiesV2Service } from "app/modules/davesa/apps/studies/studies-v2.service";
import { ParticipantsV2Service } from "app/modules/davesa/apps/participants/participants-v2.service";

const USERS = "users";
const ALL_USERS = "allUsers";

const httpOptions = {
  context: new HttpContext().set(AUTH_DAVESA_API, true),
};

const SITES = "sites";
const STUDIES = "studies";
const PARTICIPANTS = "participants";

export const SearchV2Service = createInjectable(() => {
  const _sitesV2Service = inject(SitesV2Service);
  const _studiesV2Service = inject(StudiesV2Service);
  const _participantsV2Service = inject(ParticipantsV2Service);
  const loginUser = inject(AuthDavesaV2Service).loginUser();

  const _router = inject(Router);
  const _httpClient = inject(HttpClient);

  const sites = signal<any[] | null>(null);
  const studies = signal<any[] | null>(null);
  const participants = signal<any[] | null>(null);

  //   const loadFromStorage = () => {
  //     loading.set(true);
  //     error.set(null);
  //     try {
  //       // const jsonusers = encryptStorage.getItem(USERS);
  //       // users.set(jsonusers)
  //       // const jsonallusers = encryptStorage.getItem(ALL_USERS);
  //       // allUsers.set(jsonallusers)
  //     } catch (err) {
  //       error.set(err);
  //       console.error("Error loading user from storage:", err);
  //     }
  //     loading.set(false);
  //   };

  //   const setToStorage = () => {
  //     loading.set(true);
  //     error.set(null);
  //     try {
  //       // encryptStorage.setItem(USERS, JSON.stringify(users()));
  //       // encryptStorage.setItem(ALL_USERS, JSON.stringify(allUsers()));
  //     } catch (err) {
  //       error.set(err);
  //       console.error("Error setting user to storage:", err);
  //     }
  //     loading.set(false);
  //   };

  //   const removeFromStorage = () => {
  //     loading.set(true);
  //     error.set(null);
  //     try {
  //       // encryptStorage.removeItem(USERS);
  //       // encryptStorage.removeItem(ALL_USERS);
  //     } catch (err) {
  //       error.set(err);
  //       console.error("Error removing user from storage:", err);
  //     }
  //     loading.set(false);
  //   };

  const getAllSearch = () => {
    if(loginUser) {
    _sitesV2Service.getAllSites().then((res: any) => {
        const results = res.data;
        const transformedArray = results.map((item) => ({
          oid: item.oid,
          name: item.site_name,
        }));
        sites.set(transformedArray);
        // setToStorage();

        _studiesV2Service.getAllStudies().then((res: any) => {
            const results = res.data;
            const transformedArray = results.map((item) => ({
              oid: item.oid,
              name: item.number,
            }));
            studies.set(transformedArray);
            // setToStorage();

            _participantsV2Service.getAllParticipants().then((res: any) => {
                const results = res.data;
                const transformedArray = results.map((item) => ({
                  oid: item.oid,
                  name: item.subject_id,
                }));
                participants.set(transformedArray);
                // setToStorage();
              });
          });      
      });
    } else {
      return of([]);
    }
  };

  const getAllSites = () => {
    return _sitesV2Service.getAllSites().then((res: any) => {
          const results = res.data;
          const transformedArray = results.map((item) => ({
            oid: item.oid,
            name: item.site_name,
          }));
          sites.set(transformedArray);
          return res;
        });
  };

  const getAllStudies = () => {
    return _studiesV2Service.getAllStudies().then((res: any) => {
          const results = res.data;
          const transformedArray = results.map((item) => ({
            oid: item.oid,
            name: item.number,
          }));
          studies.set(transformedArray);
          return res;
        });
  }

  const getAllParticipants = () => {
    return _participantsV2Service.getAllParticipants().then((res: any) => {
          const results = res.data;
          const transformedArray = results.map((item) => ({
            oid: item.oid,
            name: item.subject_id,
          }));
          participants.set(transformedArray);
          return res;
        });
  };

  return {
    sites: computed(() => sites()),
    studies: computed(() => studies()),
    participants: computed(() => participants()),
    getAllSearch,
    getAllSites,
    getAllStudies,
    getAllParticipants,
  };
});
